import { render, staticRenderFns } from "./postTask.vue?vue&type=template&id=163dad60&scoped=true"
import script from "./postTask.vue?vue&type=script&lang=js"
export * from "./postTask.vue?vue&type=script&lang=js"
import style0 from "./postTask.vue?vue&type=style&index=0&id=163dad60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163dad60",
  null
  
)

export default component.exports